export default __webpack_public_path__ + "static/media/direction.3a8cc680.svg";